export default __webpack_public_path__ + "static/media/icon-tele.c31a2837.svg";